import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { number } from 'yup';
import { getPayCodeDatatableAsync,getPayCodeByIdAsync,updatePayCodeAsync,checkedState, unCheckedState,checkedAllState,unCheckedAllState, deletePayCodeAsync } from './payCodeSlice';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import clsx from "clsx";
const itemClass = 'ms-1 ms-lg-0';

const PayCodeItem = (props: any) => {
    const { payCodeList, modelRef, t, onopenModal, oncloseModal, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.payCode);
    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountPayCodeId: number) => {
        dispatch(getPayCodeByIdAsync(AccountPayCodeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onDeleteClick = (AccountPayCodeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deletePayCodeAsync(AccountPayCodeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Pay code deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountPayCode: any) => {
        const { checked } = e.target;
        const foundIndex = payCodeList.findIndex((item: any) => item.AccountPayCodeId === AccountPayCode.AccountPayCodeId);
        if (foundIndex !== -1) {
            const foundItem = payCodeList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...payCodeList.slice(0, foundIndex), updatedItem, ...payCodeList.slice(foundIndex + 1)];
            dispatch(updatePayCodeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Pay code Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }


    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                    {IsDelete &&
                        <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={payCodeList.every((item: any) => item.isSelected === 0) ? false :
                                        (payCodeList.every((item: any) => item.isSelected === 1 ? true : false))
                                    }
                                    onChange={handleSelectAllChange}
                                />
                            </div>
                        </th>
}                       <th className='w-25'>{t('Pay Code')}</th>
                        <th className='w-25'>{t('Code')}</th>
                        <th className='w-25'>{t('Description')}</th>
                        {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        }
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {payCodeList.length === 0 && <tr><td>{t('No Record Found.')}</td></tr>}
                    {payCodeList.length > 0 && payCodeList.map((payCodeDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check "
                                            checked={payCodeDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, payCodeDetail.AccountPayCodeId) }}

                                        />
                                    </div>
                                </td>
                            }
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor ' onClick={IsEdit ? () => onEditClick(payCodeDetail.AccountPayCodeId) : undefined}>
                                <span className="   d-block "
                                >{payCodeDetail.Name}</span>
                            </td>
                            <td>{payCodeDetail.Code}
                            </td>
                            <td>{payCodeDetail.Description}
                            </td>
                            {IsEdit &&
                                <td className='text-center'>

                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={payCodeDetail.IsDisabled === true ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, payCodeDetail) }}
                                        />
                                    </div>

                                </td>
                            }
                             <td className='text-center' >
                                <div className={clsx('app-navbar-item', itemClass)}>
                                            <Dropdown
                                                style={{ marginLeft: 1 }}
                                                className={clsx('cursor-pointer symbol')}
                                                data-kt-menu-attach='parent'
                                                data-kt-menu-placement='bottom-end'
                                            >
                                                <Dropdown.Toggle
                                                    variant="transparent"
                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                    data-tooltip-id="tooltip-Description"
                                                    data-tooltip-content={"More"}
                                                    data-tooltip-place="bottom"
                                                >
                                                    <i className="bi bi-three-dots fs-7 " ></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu
                                                    className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-7 w-150px'>
                                                    {IsEdit &&
                                                        <>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => {
                                                                        dispatch(getPayCodeByIdAsync(payCodeDetail.AccountPayCodeId))
                                                                            .unwrap()
                                                                            .then((originalPromiseResult) => {
                                                                                onopenModal();
                                                                            })
                                                                            .catch((rejectedValueOrSerializedError) => {
                                                                            })
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">{`${t('Edit')}`}</span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                    {IsDelete && IsEdit &&
                                                        <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                    }
                                                    {IsDelete &&
                                                        <>
                                                            <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onDeleteClick(payCodeDetail.AccountPayCodeId) }}>
                                                                    <span className="menu-icon  custom-menu">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title   delete-menu custom-menu-fontsize"  >{`${t('Delete')}`}</span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                </Dropdown.Menu>
                                        </Dropdown>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
    // const {payCodeList, payCodeDetail } = props;
    // const dispatch = useAppDispatch();
    // const [pageSize,setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };
    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTerm(value);
    //     setCurrentPage(1); // Reset to the first page when searching
    // };
    // const handlePageSizeChange = (event:any) => {
    //     const { value } = event.target;
    //     setPageSize(Number(value));
    //     setCurrentPage(1); // Reset to the first page when changing itemsPerPage
    //   };

    // // Filtering and pagination logic
    // const filteredData = payCodeList.filter((item: any) =>
    //     item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = payCodeList.length;
    // console.log('length', totalItems, currentItems.length, filteredData);
    // const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);

    // const handleCheckboxChange = (e: any, rowId: any) => {
    //     if (e.target.checked) {
    //        dispatch(checkedState(rowId))
    //     } else {
    //         dispatch(unCheckedState(rowId))
    //     }
    //     console.log('payCodeList:', payCodeList);
    // };
    // const onEditClick = (AccountPayCodeId: number) => {
    //     dispatch(getPayCodeByIdAsync(AccountPayCodeId))
    //         .unwrap()
    //         .then((originalPromiseResult) => {
    //             //modelRef.current.click();
    //         })
    //         .catch((rejectedValueOrSerializedError) => {
    //             console.log('getAccountPaidThroughByIAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
    //         })
    // }
    // const onDeleteClick = (AccountPayCodeId: number) => {
    //     ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
    //         .then((result) => {
    //             if (result) {
    //                 dispatch(deletePayCodeAsync(AccountPayCodeId))
    //                     .unwrap()
    //                     .then((originalPromiseResult) => {
    //                         ShowToast("Deleted Successfully", 'Success', "success", "toast-top-right");
    //                         dispatch(getPayCodeDatatableAsync());
    //                     })
    //                     .catch((rejectedValueOrSerializedError) => {
    //                         console.log('onDeleteClick-deletePaymentMethodsAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
    //                     })
    //             }
    //         })
    //         .catch((error) => {
    //             console.log("ShowSwalWithConfirmation:error ", error);
    //         });

    // }

    // const handleSelectAllChange = (e: any) => {
    //     const { checked } = e.target;
    //     if (checked) {
    //         dispatch(checkedAllState());
    //     } else {
    //         dispatch(unCheckedAllState());
    //     }
    // };

    // return (
    //     <>
    //         <div className='row' >
    //             <div className='col-md-6'>
    //                 <div className="d-flex align-items-center position-relative my-1">
    //                     <i className="ki-duotone ki-magnifier fs-1 position-absolute ms-6">
    //                         <span className="path1"></span>
    //                         <span className="path2"></span>
    //                     </i>
    //                     <input
    //                         type="text"
    //                         value={searchTerm}
    //                         onChange={handleSearch}
    //                         placeholder={t("Search Pay Code")}
    //                         className='form-control form-control-solid w-250px ps-14'
    //                         data-kt-user-table-filter="search"
    //                     />
    //                 </div>
    //             </div>
    //             <div className='col-md-6'>
    //                 <div className="dataTables_length float-end" id="kt_datatable_zero_configuration_length">
    //                     <label>
    //                         <select name="kt_datatable_zero_configuration_length" aria-controls="kt_datatable_zero_configuration" 
    //                                className="form-select form-select form-select-solid"
    //                                value={pageSize} onChange={handlePageSizeChange}
    //                                >
    //                             <option value="10">10</option>
    //                             <option value="20">20</option>
    //                             <option value="30">30</option>
    //                             <option value="40">40</option>
    //                             <option value="50">50</option>
    //                         </select>
    //                     </label>
    //                 </div>
    //             </div>
    //         </div>


    //         <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
    //             <thead>
    //                 <tr className="fw-bold text-muted">
    //                     <th className='w-25px'>
    //                         <div className='form-check form-check-sm form-check-custom form-check-solid'>
    //                             <input
    //                                 className='form-check-input'
    //                                 type='checkbox'
    //                                 checked={payCodeList.every((item: any) => item.isSelected === 0) ? false :
    //                                     (payCodeList.every((item: any) => item.isSelected === 1 ? true : false))
    //                                 }
    //                                 onChange={handleSelectAllChange}
    //                             />
    //                         </div>
    //                     </th>
    //                     <th className='min-w-100% text-uppercase'>{t('Pay Code')}</th>
    //                     <th className='min-w-100% text-uppercase'>{t('Code')}</th>
    //                     <th className='min-w-100% text-uppercase'>{t('Description')}</th>
    //                     <th className='min-w-100% text-uppercase'>{t('Actions')}</th>
    //                 </tr>
    //             </thead>
    //             <tbody>
    //                 {currentItems.length === 0 && <tr><td>No Record Found.</td></tr>}
    //                 {currentItems.length > 0 && currentItems.map((payCodeDetail: any, i: any) => (
    //                     <tr key={i}>
    //                         <td>
    //                              <div className='form-check form-check-sm form-check-custom form-check-solid'>
    //                                 <input
    //                                     type="checkbox"
    //                                     className="form-check-input widget-9-check"
    //                                     checked={payCodeDetail.isSelected == 0 ? false : true}
    //                                     onChange={(e) => { handleCheckboxChange(e, payCodeDetail.AccountPayCodeId) }}
    //                                 />
    //                             </div>
    //                         </td>
    //                           <td> <a id="kt_OffCanvas"
    //                                 className='text-gray-800 fw-normal text-hover-primary d-block  fw-bold'
    //                                 style={{ cursor: 'pointer' }}
    //                                 onClick={() => { onEditClick(payCodeDetail.AccountPayCodeId) }}>
    //                                 {payCodeDetail.Name}
    //                             </a>
    //                             <span className={payCodeDetail.IsDisabled === true ? "badge badge-light-dark text-gray-700 fs-7" : "badge badge-light-success fs-7"}>{payCodeDetail.IsDisabled === true ? 'InActive' : 'Active'}</span>
    //                         </td>
    //                         <td> 
    //                         {payCodeDetail.Code}
    //                         </td>
    //                         <td> 
    //                         {payCodeDetail.Description}
    //                         </td>
    //                         <td className='text-end'>
    //                             <div className='d-flex justify-content-end flex-shrink-0'>
    //                                 <a id="kt_OffCanvas" className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
    //                                     onClick={() => { onEditClick(payCodeDetail.AccountPayCodeId) }}>
    //                                     <KTIcon iconName='pencil' className='fs-3' />
    //                                 </a>
    //                                 <a className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
    //                                     onClick={() => { onDeleteClick(payCodeDetail.AccountPayCodeId) }}>
    //                                     <KTIcon iconName='trash' className='fs-3' />
    //                                 </a>
    //                             </div>
                              
    //                         </td>
    //                     </tr>
    //                 ))}
    //             </tbody>
    //         </table>
    //         <div>
    //             {(currentItems.length > 0) ? (
    //                 <CustomPagination
    //                     currentPage={currentPage}
    //                     onPageChange={handlePageChange}
    //                     pageSize={pageSize}
    //                     totalItems={totalItems}
    //                     start={(currentPage - 1) * pageSize}
    //                 >
    //                 </CustomPagination>
    //             ) : null}
    //         </div>
    //     </>
    // )
}

export default PayCodeItem